module.exports = require('./helpers/bundle-url').getBundleURL('aU9Vj') + "beep.f20d5237.mp3";